import { Banner, BlockStack, Checkbox, Form, FormLayout, Text, Modal, Select, TextField, ChoiceList, Spinner, Button } from '@shopify/polaris';
import { DeleteIcon, PageDownIcon, SaveIcon } from '@shopify/polaris-icons';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { notEmpty, useField, useForm } from '@shopify/react-form';
import { useNotification } from 'context/NotificationContext';
import helpers from 'helpers/index';
import __ from 'languages/index';
import { useMutateDeleteOrderTaxInformation, useMutateOrderTaxInformation, useGetOrder } from 'queries/orders.query';

type BusinessTaxLookupResponse = {
  code?: string;
  desc?: string;
  data?: {
    id?: string;
    name?: string | null;
    address?: string | null;
    status?: string;
  } | null;
  metadata?: any;
};

type EditOrderTaxModalProps = {
  open: boolean;
  orderId: string | null;
  onClose: (reload?: boolean) => void;
};

export default function EditOrderTaxModal({ open, orderId, onClose }: EditOrderTaxModalProps) {
  const { addNotification } = useNotification();
  const { mutateAsync: updateOrderTaxInformation, isPending: updatingInvoice } = useMutateOrderTaxInformation();
  const { mutateAsync: deleteOrderTaxInformation, isPending: deletingInvoice } = useMutateDeleteOrderTaxInformation();
  const { data: orderData } = useGetOrder(orderId || '');

  const [selectedTaxInformationId, setSelectedTaxInformationId] = useState<string>('default');
  const [taxLookupError, setTaxLookupError] = useState('');
  const [taxLookupMessage, setTaxLookupMessage] = useState('');
  const [taxLookupLoading, setTaxLookupLoading] = useState(false);

  // const { data: taxInformationData } = useGetUserTaxInformations({
  //   user_id: orderData?.customer_data?.user_id,
  //   limit: 50,
  //   sort: 'createdAt:desc',
  // });

  // const taxInformations = useMemo<TypedUser_tax_information[]>(() => taxInformationData?.body ?? [], [taxInformationData]);

  const invoiceFields = {
    invoice_tax_type: useField<string>({ value: orderData?.order_invoice_info?.tax_type || 'COMPANY', validates: [] }),
    name: useField<string>({ value: orderData?.order_invoice_info?.name || orderData?.customer_data?.display_name || 'Khách lẻ', validates: [] }),
    buyer_name: useField<string>({
      value: orderData?.order_invoice_info?.buyer_name || '',
      validates: [],
    }),
    invoice_tax_code: useField<string>({ value: orderData?.order_invoice_info?.tax_code || '', validates: [] }),
    invoice_tax_cccd: useField<string>({ value: orderData?.order_invoice_info?.tax_cccd || '', validates: [] }),
    invoice_email: useField<string>({
      value: orderData?.order_invoice_info?.invoice_email || '',
      validates: [
        notEmpty('Không được để trống trường này!'),

        (inputVal) => {
          if (inputVal && !helpers.isEmail(inputVal)) return 'Phải là một Email hợp lệ!';
        },
      ],
    }),
    invoice_phone: useField<string>({
      value: orderData?.order_invoice_info?.invoice_phone || orderData?.customer_data?.user_phonenumber || '',
      validates: [],
    }),
    invoice_address: useField<string>({ value: orderData?.order_invoice_info?.invoice_address || '', validates: [] }),
    invoice_save_to_invoice_list: useField<string>({ value: '0', validates: [] }),
  };

  const normalizedTaxCode = useMemo(() => invoiceFields.invoice_tax_code.value.trim(), [invoiceFields.invoice_tax_code.value]);

  // const applyTaxInformationToFields = useCallback((taxInformation?: TypedUser_tax_information) => {
  //   invoiceFields.invoice_tax_type.onChange(taxInformation?.tax_type);
  //   invoiceFields.name.onChange(taxInformation?.name || '');
  //   invoiceFields.buyer_name.onChange(taxInformation?.buyer_name || '');
  //   invoiceFields.invoice_tax_code.onChange(taxInformation?.tax_code || '');
  //   invoiceFields.invoice_tax_cccd.onChange(taxInformation?.tax_cccd || '');
  //   invoiceFields.invoice_email.onChange(taxInformation?.invoice_email || '');
  //   invoiceFields.invoice_phone.onChange(taxInformation?.invoice_phone || '');
  //   invoiceFields.invoice_address.onChange(taxInformation?.invoice_address || '');
  // }, []);

  // const applyOrderInvoiceInfoToFields = useCallback(() => {
  //   applyTaxInformationToFields({
  //     tax_type: orderData?.order_invoice_info?.tax_type || 'COMPANY',
  //     name: orderData?.order_invoice_info?.name || orderData?.customer_data?.display_name || 'Khách lẻ',
  //     buyer_name: orderData?.order_invoice_info?.buyer_name || '',
  //     tax_code: orderData?.order_invoice_info?.tax_code || '',
  //     tax_cccd: orderData?.order_invoice_info?.tax_cccd || '',
  //     invoice_email: orderData?.order_invoice_info?.invoice_email || '',
  //     invoice_phone: orderData?.order_invoice_info?.invoice_phone || orderData?.customer_data?.user_phonenumber || '',
  //     invoice_address: orderData?.order_invoice_info?.invoice_address || '',
  //   });
  // }, [applyTaxInformationToFields, orderData]);

  // useEffect(() => {
  //   if (!orderData) return;
  //   if (orderData.order_invoice_info) {
  //     applyOrderInvoiceInfoToFields();
  //     return;
  //   }
  // }, [applyOrderInvoiceInfoToFields, applyTaxInformationToFields, orderData]);

  useEffect(() => {
    if (!orderData) return;
    // if (helpers.isEmpty(taxInformations)) {
    //   setSelectedTaxInformationId('default');
    //   return;
    // }
    const orderInvoiceInfo = orderData?.order_invoice_info;
    if (!orderInvoiceInfo) {
      setSelectedTaxInformationId('default');
      return;
    }
    // const matchedTaxInformation = taxInformations.find(
    //   (taxInformation) =>
    //     String(taxInformation?.id) === String(orderInvoiceInfo?.id) ||
    //     (!!taxInformation?.tax_code && taxInformation?.tax_code === orderInvoiceInfo?.tax_code)
    // );
    // setSelectedTaxInformationId(matchedTaxInformation ? String(matchedTaxInformation.id) : 'default');
  }, [orderData]);

  // const taxInformationOptions = useMemo(() => {
  //   const options = taxInformations.map((taxInformation) => {
  //     const baseLabel = taxInformation?.name || taxInformation?.tax_code || 'Thông tin thuế';
  //     const labelSuffix = taxInformation?.tax_code ? ` - ${taxInformation.tax_code}` : '';
  //     const defaultSuffix = taxInformation?.is_default ? ' (Mặc định)' : '';
  //     return {
  //       label: `${baseLabel}${labelSuffix}${defaultSuffix}`,
  //       value: String(taxInformation?.id),
  //     };
  //   });
  //   return [{ label: 'Hóa đơn mặc định', value: 'default' }, ...options];
  // }, [taxInformations]);

  // const handleTaxInformationChange = useCallback(
  //   async (value: string) => {
  //     setSelectedTaxInformationId(value);

  //     const selectedTaxInformation = taxInformations.find((taxInformation) => String(taxInformation?.id) === value);
  //     if (!selectedTaxInformation) return;
  //     applyTaxInformationToFields(selectedTaxInformation);
  //   },
  //   [applyTaxInformationToFields, orderData, taxInformations]
  // );

  const fetchBusinessTaxInformation = useCallback(async () => {
    const controller = new AbortController();
    setTaxLookupError('');
    setTaxLookupMessage('');
    setTaxLookupLoading(true);

    try {
      const response = await fetch(`https://api.vietqr.io/v2/business/${encodeURIComponent(normalizedTaxCode)}`, { signal: controller.signal });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const result = (await response.json()) as BusinessTaxLookupResponse;
      if (result?.code !== '00' || !result?.data) {
        throw new Error(result?.desc || 'Không tìm thấy doanh nghiệp tương ứng với mã số thuế đã nhập.');
      }

      if (controller.signal.aborted) return;

      let companyAddress = result.data?.address?.trim().replace('TP ', 'Thành phố ');
      if (!companyAddress.includes('Việt Nam')) {
        companyAddress = companyAddress + ', Việt Nam';
      }
      if (!invoiceFields.name.value.trim() || selectedTaxInformationId === 'default') {
        invoiceFields.name.onChange(result.data?.name?.trim() || invoiceFields.name.value);
      }
      if (!invoiceFields.invoice_address.value.trim() || selectedTaxInformationId === 'default') {
        invoiceFields.invoice_address.onChange(companyAddress || invoiceFields.invoice_address.value);
      }

      setTaxLookupMessage(`Đã tự động điền thông tin công ty từ mã số thuế. ${result?.data?.status}`);
    } catch (error: any) {
      if (controller.signal.aborted) return;
      setTaxLookupError(error?.message || 'Không thể tra cứu thông tin mã số thuế. Vui lòng kiểm tra lại.');
    } finally {
      if (controller.signal.aborted) return;
      setTaxLookupLoading(false);
    }
  }, [invoiceFields.invoice_address, invoiceFields.name, normalizedTaxCode, selectedTaxInformationId]);

  useEffect(() => {
    setTaxLookupError('');
    setTaxLookupMessage('');
    setTaxLookupLoading(false);
  }, [normalizedTaxCode, open]);

  const { submit, submitting, dirty } = useForm({
    fields: invoiceFields,
    async onSubmit(values) {
      if (!orderData?.id) return { status: 'fail', errors: [] };
      try {
        await updateOrderTaxInformation({
          order_id: String(orderData?.id ?? orderId),
          tax_type: values.invoice_tax_type,
          name: values.name,
          buyer_name: values.buyer_name,
          tax_code: values.invoice_tax_code,
          tax_cccd: values.invoice_tax_cccd,
          invoice_email: values.invoice_email,
          invoice_phone: values.invoice_phone,
          invoice_address: values.invoice_address,
          invoice_save_to_invoice_list: Number(values.invoice_save_to_invoice_list),
        });
        addNotification('info', 'Cập nhật thông tin thuế thành công!');
        onClose(true);
      } catch (e: any) {
        if (e.params !== undefined) {
          if (e.params.field !== undefined) {
            invoiceFields[e.params.field]?.setError(__('check_this_field_again'));
          }
        }
      }
      return { status: 'success', errors: [] };
    },
  });

  const deleteInvoiceCallback = useCallback(async () => {
    if (!orderData?.id) return;
    try {
      await deleteOrderTaxInformation(orderData?.id);
      addNotification('info', 'Xoá thông tin thuế thành công!');
      onClose(true);
    } catch (e) {
      console.error(e, 'ERR_DELETE_INVOICE');
      addNotification('error', 'Lỗi xoá thông tin thuế!');
    }
  }, [addNotification, deleteOrderTaxInformation, onClose, orderData]);

  useEffect(() => {
    if (!open) return;
    helpers.resetForm(invoiceFields);
  }, [open]);

  const isDisableForm = orderData?.is_exported_invoice === 1;
  const isLoading = updatingInvoice || deletingInvoice || submitting;

  return (
    <Modal
      open={open}
      title={`Thông tin thuế đơn hàng ${orderData?.order_code ? `#${orderData?.order_code}` : ''}`.trim()}
      onClose={() => onClose(false)}
      primaryAction={{
        content: 'Cập nhật thông tin thuế',
        icon: SaveIcon,
        disabled: isDisableForm || !dirty,
        loading: isLoading,
        onAction: submit,
      }}
      secondaryActions={[
        {
          destructive: true,
          content: 'Xoá bỏ',
          icon: DeleteIcon,
          disabled: !orderData?.order_invoice_info || isLoading || isDisableForm,
          onAction: deleteInvoiceCallback,
        },
      ]}
    >
      <Modal.Section>
        <Form onSubmit={submit}>
          <BlockStack gap="400">
            <FormLayout>
              {orderData?.invoiceExportedAt ? (
                <Text as="p" variant="bodySm" tone="caution">
                  ‼️ Thông tin thuế đã được xuất hóa đơn vào ngày {new Date(Number(orderData.invoiceExportedAt)).toLocaleString()}. Vui lòng liên hệ
                  bộ phận kế toán để chỉnh sửa thông tin thuế.
                </Text>
              ) : null}

              {orderData?.order_invoice_info?.is_customer_required === 1 ? (
                <Text as="p" variant="headingSm" fontWeight="bold">
                  ⚠️ Thông tin này đã được người dùng thêm vào, lưu ý khi chỉnh sửa.
                </Text>
              ) : null}

              <ChoiceList
                title="Loại thuế suất"
                choices={[
                  {
                    label: 'Hóa đơn cá nhân',
                    value: 'PERSONAL',
                  },
                  {
                    label: 'Hóa đơn doanh nghiệp',
                    value: 'COMPANY',
                  },
                ]}
                selected={[invoiceFields.invoice_tax_type.value]}
                onChange={(value) => invoiceFields.invoice_tax_type.onChange(value.pop())}
              />

              {invoiceFields.invoice_tax_type.value === 'PERSONAL' ? (
                <BlockStack gap="100">
                  <TextField
                    autoComplete="off"
                    label="Số căn cước công dân"
                    disabled={isLoading || isDisableForm}
                    {...invoiceFields.invoice_tax_cccd}
                  />
                  <TextField
                    autoComplete="off"
                    label="Tên trên Căn cước"
                    requiredIndicator
                    disabled={isLoading || isDisableForm}
                    {...invoiceFields.name}
                  />
                </BlockStack>
              ) : (
                <BlockStack gap="100">
                  <TextField
                    autoComplete="off"
                    label="Mã số thuế"
                    clearButton
                    onClearButtonClick={() => {
                      invoiceFields.invoice_tax_code.onChange('');
                    }}
                    disabled={isLoading || isDisableForm}
                    {...invoiceFields.invoice_tax_code}
                    connectedRight={
                      <Button onClick={() => fetchBusinessTaxInformation()} icon={PageDownIcon} disabled={isLoading || isDisableForm}>
                        Lấy thông tin
                      </Button>
                    }
                  />
                  {taxLookupLoading ? (
                    <Text as="p" variant="bodySm" tone="subdued">
                      <Spinner size="small" /> Đang tra cứu thông tin doanh nghiệp...
                    </Text>
                  ) : null}
                  {taxLookupError ? <Banner tone="critical">{taxLookupError}</Banner> : null}
                  {taxLookupMessage ? <Banner tone="success">{taxLookupMessage}</Banner> : null}
                  <TextField autoComplete="off" label="Tên người mua" disabled={isLoading || isDisableForm} {...invoiceFields.buyer_name} />
                  <TextField autoComplete="off" label="Tên công ty" requiredIndicator disabled={isLoading || isDisableForm} {...invoiceFields.name} />
                </BlockStack>
              )}
              <TextField autoComplete="off" label="Địa chỉ xuất hóa đơn" disabled={isLoading || isDisableForm} {...invoiceFields.invoice_address} />
              <FormLayout.Group>
                <TextField
                  autoComplete="off"
                  label="Email nhận hóa đơn"
                  requiredIndicator
                  disabled={isLoading || isDisableForm}
                  {...invoiceFields.invoice_email}
                />
                <TextField autoComplete="off" label="Số điện thoại" disabled={isLoading || isDisableForm} {...invoiceFields.invoice_phone} />
              </FormLayout.Group>
              {!orderData?.order_invoice_info ? (
                <Checkbox
                  label="Lưu vào danh sách hóa đơn, sử dụng cho các đơn hàng sau"
                  checked={invoiceFields.invoice_save_to_invoice_list.value === '1'}
                  onChange={(value) => {
                    invoiceFields.invoice_save_to_invoice_list.onChange(String(Number(value)));
                  }}
                  disabled={isLoading || isDisableForm}
                />
              ) : null}
            </FormLayout>
          </BlockStack>
        </Form>
      </Modal.Section>
    </Modal>
  );
}

